import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ProductBasedCollectionPageWrapper } from "@faire/retailer-visitor-shared/views/product-based-collection/__internal__/__internal__/ProductBasedCollectionPageWrapper";
import { Spacer } from "@faire/web--source/slate/spacing";
import * as React from "react";
export var ProductBasedCollectionErrorContent = function(param) {
    var errorMessage = param.errorMessage;
    return /*#__PURE__*/ _jsxs(ProductBasedCollectionPageWrapper, {
        "data-test-id": "collection-error-content",
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                width: 20
            }),
            errorMessage,
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            })
        ]
    });
};
